/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from "react";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import StringEntry from "../datatypeComponents/StringEntry";
import RangeEntry, { displayStringFromFHIRRange } from "../datatypeComponents/RangeEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../datatypeComponents/QuantityEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, displayStringFromFHIRCodeableConcept } from "../datatypeComponents/CodeableConceptEntry";
import { DisplayFromFHIRExpression } from "../datatypeComponents/ExpressionEntry";
import { displayStringFromFHIRBoolean } from "../datatypeComponents/BooleanEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import UnsignedIntEntry from "../datatypeComponents/UnsignedIntEntry";
import { Button, Dropdown, Table } from "semantic-ui-react";
import SEVCO, { attributeStatisticsConceptSet, categoricalStatisticsConceptSet, comparativeStatisticsConceptSet, continuousStatisticsConceptSet, dichotomousStatisticsConceptSet, statisticTypeCodeableConceptSet } from "../dictionaries/SEVCO";
import DecimalEntry from "../datatypeComponents/DecimalEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import ExpandToAddOrEdit from "./ExpandToAddOrEdit";

const ModelCharacteristicDisplay = ({ modelCharactersticInstance }) => {
    let modelVariable = <></>;
    let modelVariableFound = false;
    if (modelCharactersticInstance.variable) {
        modelVariable = <>Adjusted for:<ul style={{ marginTop: "0px" }}>{modelCharactersticInstance.variable.map((variable, variableIndex) => {
            if (variable.variableDefinition) {
                modelVariableFound = true;
                let includeIfFound = false;
                let includeIfString;
                if (variable.extension?.length > 0) {
                    for (const extension of variable.extension) {
                        if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                            extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                            extension.url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                            includeIfFound = true;
                            includeIfString = " {{ include if ";
                            for (const ext of extension.extension) {
                                if (ext.url === "attribute") {
                                    includeIfString += displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept) || "";
                                    includeIfString += " IS "
                                } else if (ext.url === "value") {
                                    if (typeof ext.valueBoolean === 'boolean') {
                                        includeIfString += displayStringFromFHIRBoolean(ext.valueBoolean);
                                    } else if (ext.valueCodeableConcept) {
                                        includeIfString += displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept);
                                    } else if (ext.valueQuantity) {
                                        includeIfString += displayStringFromFHIRQuantity(ext.valueQuantity);
                                    } else if (ext.valueRange) {
                                        includeIfString += displayStringFromFHIRRange(ext.valueRange);
                                    } else if (ext.valueExpression) {
                                        includeIfString += ext.valueExpression.name + " " + ext.valueExpression.description + " " + ext.valueExpression.expression;
                                    }
                                }
                            }
                            includeIfString += " }}";
                        }
                    }
                }
                return <li key={variableIndex}>{variable.variableDefinition.display && <>{variable.variableDefinition.display}</>} {variable.handling && <>({variable.handling})</>} {includeIfFound && <>{includeIfString}</>}</li>
            } else {
                return <></>
            }
        })}</ul></>
    }
    let modelAttributeEstimate = <></>;
    let modelAttributeEstimateFound = false;
    if (modelCharactersticInstance.attribute || modelCharactersticInstance.attributeEstimate) {
        modelAttributeEstimate = <><p>Placeholder -- this model characteristic contains one or more attribute estimates</p></>;
        modelAttributeEstimateFound = true;
    }
    let includeIfFound = false;
    let includeIfExtension;
    if (modelCharactersticInstance.extension?.length > 0) {
        for (const extension of modelCharactersticInstance.extension) {
            if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                extension.url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                includeIfFound = true;
                includeIfExtension = {};
                for (const ext of extension.extension) {
                    if (ext.url === "attribute") {
                        includeIfExtension["attribute"] = ext.valueCodeableConcept || "";
                    } else if (ext.url === "value") {
                        if (typeof ext.valueBoolean === 'boolean') {
                            includeIfExtension["valueBoolean"] = ext.valueBoolean;
                        } else if (ext.valueCodeableConcept) {
                            includeIfExtension["valueCodeableConcept"] = ext.valueCodeableConcept;
                        } else if (ext.valueQuantity) {
                            includeIfExtension["valueQuantity"] = ext.valueQuantity;
                        } else if (ext.valueRange) {
                            includeIfExtension["valueRange"] = ext.valueRange;
                        } else if (ext.valueExpression) {
                            includeIfExtension["valueExpression"] = ext.valueExpression;
                        }
                    }
                }
            }
        }
    }
    return <>
        {includeIfFound && <div>
            <b>Include if: </b>
            <div style={{ marginLeft: "24px" }}>
                <div>
                    <b>Attribute: </b>
                    <DisplayFromFHIRCodeableConcept codeableConcept={includeIfExtension.attribute} />
                </div>
                <div>
                    <b>Value: </b>
                    {typeof includeIfExtension.valueBoolean === 'boolean' &&
                        displayStringFromFHIRBoolean(includeIfExtension.valueBoolean)}
                    {includeIfExtension.valueCodeableConcept &&
                        <DisplayFromFHIRCodeableConcept codeableConcept={includeIfExtension.valueCodeableConcept} />}
                    {includeIfExtension.valueQuantity &&
                        displayStringFromFHIRQuantity(includeIfExtension.valueQuantity)}
                    {includeIfExtension.valueRange &&
                        displayStringFromFHIRRange(includeIfExtension.valueRange)}
                    {includeIfExtension.valueExpression &&
                        <DisplayFromFHIRExpression expression={includeIfExtension.valueExpression} />}
                </div>
            </div>
        </div>}
        {modelCharactersticInstance.conditionCodeableConcept && <span>
            <b>If this condition is met: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.conditionCodeableConcept} />
        </span>}
        {modelCharactersticInstance.conditionExpression && <span>
            <b>If this condition is met: </b>
            <DisplayFromFHIRExpression expression={modelCharactersticInstance.conditionExpression} />
        </span>}
        {modelCharactersticInstance.code && <span>
            <br />
            <b>Code: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.code} />
        </span>}
        {modelCharactersticInstance.value && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRQuantity(modelCharactersticInstance.value)}
        </span>}
        {modelCharactersticInstance.valueQuantity && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRQuantity(modelCharactersticInstance.valueQuantity)}
        </span>}
        {modelCharactersticInstance.valueRange && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRRange(modelCharactersticInstance.valueRange)}
        </span>}
        {modelCharactersticInstance.valueCodeableConcept && <span>
            <br />
            <b>Value: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.valueCodeableConcept} />
        </span>}
        {modelCharactersticInstance.intended && <p><b>Intended: </b>True</p>}
        {modelCharactersticInstance.applied && <p><b>Applied: </b>True</p>}
        {modelVariableFound && modelVariable}
        {modelAttributeEstimateFound && modelAttributeEstimate}
        {(Array.isArray(modelCharactersticInstance.modelCharacteristic) &&
            modelCharactersticInstance.modelCharacteristic.length > 0) &&
            modelCharactersticInstance.modelCharacteristic.map((item, itemIndex) => {
                return <div key={itemIndex}>
                    <p><b>Model Characteristic {itemIndex + 1} of {modelCharactersticInstance.modelCharacteristic.length}</b></p>
                    <ModelCharacteristicDisplay modelCharactersticInstance={item} />
                </div>
            })}
    </>
}

const EvidenceStatisticSampleSizeEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle }) => {
    let startingSampleSize = {
        description: "", note: [], numberOfStudies: "", numberOfParticipants: "", numberAnalyzed: "", knownDataCount: ""
    }
    if (!startingValue) {
        startingValue = "";
    } else {
        if (startingValue.extension) { startingSampleSize.extension = startingValue.extension; }
        if (startingValue.description) { startingSampleSize.description = startingValue.description; }
        if (startingValue.note) { startingSampleSize.note = startingValue.note; }
        if (startingValue.numberOfStudies || startingValue.numberOfStudies === 0) { startingSampleSize.numberOfStudies = startingValue.numberOfStudies; }
        if (startingValue.numberOfParticipants || startingValue.numberOfParticipants === 0) { startingSampleSize.numberOfParticipants = startingValue.numberOfParticipants; }
        if (startingValue.numberAnalyzed || startingValue.numberAnalyzed === 0) { startingSampleSize.numberAnalyzed = startingValue.numberAnalyzed; }
        if (startingValue.knownDataCount || startingValue.knownDataCount === 0) { startingSampleSize.knownDataCount = startingValue.knownDataCount; }
    }

    const [evidenceStatisticSampleSizeState, setEvidenceStatisticSampleSizeState] = useState(JSON.parse(JSON.stringify(startingSampleSize || {})));

    useEffect((() => {
        if (Object.keys(evidenceStatisticSampleSizeState).length > 0) {
            let newStatisticSampleSize = {};
            if (evidenceStatisticSampleSizeState.extension) { newStatisticSampleSize.extension = evidenceStatisticSampleSizeState.extension; }
            if (evidenceStatisticSampleSizeState.description) { newStatisticSampleSize.description = evidenceStatisticSampleSizeState.description; }
            if (Array.isArray(evidenceStatisticSampleSizeState.note) && evidenceStatisticSampleSizeState.note.length > 0) {
                newStatisticSampleSize.note = evidenceStatisticSampleSizeState.note;
            }
            if (evidenceStatisticSampleSizeState.numberOfStudies || evidenceStatisticSampleSizeState.numberOfStudies === 0) {
                newStatisticSampleSize.numberOfStudies = evidenceStatisticSampleSizeState.numberOfStudies;
            }
            if (evidenceStatisticSampleSizeState.numberOfParticipants || evidenceStatisticSampleSizeState.numberOfParticipants === 0) {
                newStatisticSampleSize.numberOfParticipants = evidenceStatisticSampleSizeState.numberOfParticipants;
            }
            if (evidenceStatisticSampleSizeState.numberAnalyzed || evidenceStatisticSampleSizeState.numberAnalyzed === 0) {
                newStatisticSampleSize.numberAnalyzed = evidenceStatisticSampleSizeState.numberAnalyzed;
            }
            if (evidenceStatisticSampleSizeState.knownDataCount || evidenceStatisticSampleSizeState.knownDataCount === 0) {
                newStatisticSampleSize.knownDataCount = evidenceStatisticSampleSizeState.knownDataCount;
            }
            if (Object.keys(newStatisticSampleSize).length === 0) {
                newStatisticSampleSize = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newStatisticSampleSize }; });
        }
    }), [evidenceStatisticSampleSizeState]);

    return <>
        <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
        <div style={{ marginLeft: "24px" }}>
            <MarkdownEntry elementName='description' fieldLabel='Description'
                startingValue={evidenceStatisticSampleSizeState.description} setResourceState={setEvidenceStatisticSampleSizeState} />
            <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                startingValue={evidenceStatisticSampleSizeState.note} setResourceState={setEvidenceStatisticSampleSizeState} />
            <br /><br />
            <span><b>Number of Studies:</b>
                &nbsp;&nbsp;
                <UnsignedIntEntry elementName='numberOfStudies' fieldLabel='Number of Studies'
                    startingValue={evidenceStatisticSampleSizeState.numberOfStudies}
                    setResourceState={setEvidenceStatisticSampleSizeState} />
            </span>
            <br /><br />
            <span><b>Number of Participants:</b>
                &nbsp;&nbsp;
                <UnsignedIntEntry elementName='numberOfParticipants' fieldLabel='Number of Participants'
                    startingValue={evidenceStatisticSampleSizeState.numberOfParticipants}
                    setResourceState={setEvidenceStatisticSampleSizeState} />
            </span>
            <br /><br />
            <span><b>Number Analyzed:</b>
                &nbsp;&nbsp;
                <UnsignedIntEntry elementName='numberAnalyzed' fieldLabel='Number Analyzed'
                    startingValue={evidenceStatisticSampleSizeState.numberAnalyzed}
                    setResourceState={setEvidenceStatisticSampleSizeState} />
            </span>
            <br /><br />
            <span><b>Known Data Count:</b>
                &nbsp;&nbsp;
                <UnsignedIntEntry elementName='knownDataCount' fieldLabel='Known Data Count'
                    startingValue={evidenceStatisticSampleSizeState.knownDataCount}
                    setResourceState={setEvidenceStatisticSampleSizeState} />
            </span>
        </div>
    </>
});

const EvidenceStatisticAttributeEstimateEntry = memo(({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {
    let startingAttributeEstimate = {
        description: "", note: [], type: "", quantity: "", level: "", range: "", attributeEstimate: []
    }
    if (!startingValue) {
        startingValue = "";
    } else {
        if (startingValue.extension) { startingAttributeEstimate.extension = startingValue.extension; }
        if (startingValue.description) { startingAttributeEstimate.description = startingValue.description; }
        if (startingValue.note) { startingAttributeEstimate.note = startingValue.note; }
        if (startingValue.type) { startingAttributeEstimate.type = startingValue.type; }
        if (startingValue.quantity) { startingAttributeEstimate.quantity = startingValue.quantity; }
        if (startingValue.level) { startingAttributeEstimate.level = startingValue.level; }
        if (startingValue.range) { startingAttributeEstimate.range = startingValue.range; }
        if (startingValue.attributeEstimate) { startingAttributeEstimate.attributeEstimate = startingValue.attributeEstimate; }
    }

    const [evidenceStatisticAttributeEstimateState, setEvidenceStatisticAttributeEstimateState] = useState(JSON.parse(JSON.stringify(startingAttributeEstimate || {})));
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect((() => {
        if (Object.keys(evidenceStatisticAttributeEstimateState).length > 0) {
            let newAttributeEstimate = {};
            if (evidenceStatisticAttributeEstimateState.extension) { newAttributeEstimate.extension = evidenceStatisticAttributeEstimateState.extension; }
            if (evidenceStatisticAttributeEstimateState.description) { newAttributeEstimate.description = evidenceStatisticAttributeEstimateState.description; }
            if (Array.isArray(evidenceStatisticAttributeEstimateState.note) && evidenceStatisticAttributeEstimateState.note.length > 0) {
                newAttributeEstimate.note = evidenceStatisticAttributeEstimateState.note;
            }
            if (evidenceStatisticAttributeEstimateState.type && Object.keys(evidenceStatisticAttributeEstimateState.type).length > 0) {
                newAttributeEstimate.type = evidenceStatisticAttributeEstimateState.type;
            }
            if (evidenceStatisticAttributeEstimateState.quantity && Object.keys(evidenceStatisticAttributeEstimateState.quantity).length > 0) {
                newAttributeEstimate.quantity = evidenceStatisticAttributeEstimateState.quantity;
            }
            if (evidenceStatisticAttributeEstimateState.level || evidenceStatisticAttributeEstimateState.level === 0) {
                newAttributeEstimate.level = evidenceStatisticAttributeEstimateState.level;
            }
            if (evidenceStatisticAttributeEstimateState.range && Object.keys(evidenceStatisticAttributeEstimateState.range).length > 0) {
                newAttributeEstimate.range = evidenceStatisticAttributeEstimateState.range;
            }
            if (Array.isArray(evidenceStatisticAttributeEstimateState.attributeEstimate) && evidenceStatisticAttributeEstimateState.attributeEstimate.length > 0) {
                newAttributeEstimate.attributeEstimate = evidenceStatisticAttributeEstimateState.attributeEstimate;
            }
            if (Object.keys(newAttributeEstimate).length === 0) {
                newAttributeEstimate = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newAttributeEstimate }; });
        }
    }), [evidenceStatisticAttributeEstimateState]);

    let calculatedPercentageAttribute = false;
    let attribute = "";
    if (startingValue.level) {
        attribute = 100 * startingValue.level + "% ";
    }
    if (startingValue.type) {
        if (startingValue.type.coding?.length > 0) {
            if (startingValue.type.coding[0].display) {
                attribute += startingValue.type.coding[0].display;
            } else if (startingValue.type.coding[0].code) {
                attribute += startingValue.type.coding[0].code;
            }
        }
        if (startingValue.type.text) {
            if (startingValue.type.text.toLowerCase() === "percentage") {
                calculatedPercentageAttribute = true;
            }
            attribute += " " + startingValue.type.text;
        }
    }
    let attributeValue = "";
    if (startingValue.quantity) {
        let comparator = "";
        if (startingValue.quantity.comparator) {
            comparator = startingValue.quantity.comparator + " ";
        }
        let unit = "";
        if (startingValue.quantity.unit) {
            unit = " " + startingValue.quantity.unit;
        }
        let attributeEstimateValue = "";
        if (startingValue.quantity.value !== undefined) {
            attributeEstimateValue = startingValue.quantity.value
        }
        attributeValue = comparator + startingValue.quantity.value + unit;
        if (calculatedPercentageAttribute && startingValue.quantity.value && (comparator === "" || comparator === " ") && startingValue.quantity.unit === "%") {
            try {
                //The plus symbol belongs here, +parseFloat(4).toFixed(2) === 4 as an int vs parseFloat(4).toFixed(2) === "4.00" as a string
                attributeEstimateValue = +parseFloat(startingValue.quantity.value).toFixed(2);
                if (attributeEstimateValue.toString() !== "NaN") {
                    attributeValue = attributeEstimateValue + unit;
                }
            } catch (e) {
                console.log(e);
            }
        }
    }
    if (attributeValue === "" && startingValue.range) {
        let lowValue = "No Lower Bound";
        let highValue = "No Upper Bound";
        if (startingValue.range.low?.value !== undefined) {
            lowValue = startingValue.range.low.value;
            if (startingValue.range.low.unit) {
                lowValue += " " + startingValue.range.low.unit;
            }
        }
        if (startingValue.range.high?.value !== undefined) {
            highValue = startingValue.range.high.value;
            if (startingValue.range.high.unit) {
                highValue += " " + startingValue.range.high.unit;
            }
        }
        attributeValue = lowValue + " to " + highValue;
    }

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                <Table style={{ margin: "4px" }}>
                    <Table.Header><Table.Row>
                        <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Value</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Notes</Table.HeaderCell>
                    </Table.Row></Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>{attribute}</Table.Cell>
                            <Table.Cell>{attributeValue}</Table.Cell>
                            <Table.Cell>
                                {startingValue.description && <>
                                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                                </>}
                                {startingValue.note && <>
                                    {startingValue.note.map((note, noteIndex) => {
                                        return <span key={noteIndex}>
                                            <b>Note:</b> {note.text}<br />
                                        </span>
                                    })}
                                </>}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description' startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.description} setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.note} setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <CodeableConceptEntry elementName='type' fieldLabel='Attribute Estimate Type'
                    startingValue={evidenceStatisticAttributeEstimateState.type}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={attributeStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticAttributeEstimateState.quantity} startCollapsed
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <br /><br />
                <span><b>Level:</b>
                    &nbsp;&nbsp;
                    <DecimalEntry elementName='level' fieldLabel='Level'
                        startingValue={evidenceStatisticAttributeEstimateState.level}
                        setResourceState={setEvidenceStatisticAttributeEstimateState} />
                </span>
                <RangeEntry elementName='range' fieldLabel='Range'
                    startingValue={evidenceStatisticAttributeEstimateState.range} startCollapsed
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.attributeEstimate} setResourceState={setEvidenceStatisticAttributeEstimateState} />
            </div>
        </>
    }
});

const EvidenceStatisticEntry = memo(({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed, dataEntryStyle, outcomeHandling, outcomeCategories, populationQuantity }) => {
    let startingStatistic = {
        description: "", note: [], statisticType: "", category: "", quantity: "", numberOfEvents: "",
        numberAffected: "", sampleSize: "", attributeEstimate: [], modelCharacteristic: []
    }
    if (!startingValue) {
        startingValue = "";
    } else {
        if (startingValue.extension) { startingStatistic.extension = startingValue.extension; }
        if (startingValue.description) { startingStatistic.description = startingValue.description; }
        if (startingValue.note) { startingStatistic.note = startingValue.note; }
        if (startingValue.statisticType) { startingStatistic.statisticType = startingValue.statisticType; }
        if (startingValue.category) { startingStatistic.category = startingValue.category; }
        if (startingValue.quantity) { startingStatistic.quantity = startingValue.quantity; }
        if (startingValue.numberOfEvents || startingValue.numberOfEvents === 0) { startingStatistic.numberOfEvents = startingValue.numberOfEvents; }
        if (startingValue.numberAffected || startingValue.numberAffected === 0) { startingStatistic.numberAffected = startingValue.numberAffected; }
        if (startingValue.sampleSize) {
            startingStatistic.sampleSize = startingValue.sampleSize;
        } else if (!isNaN(populationQuantity)) {
            startingStatistic.sampleSize = populationQuantity;
        }
        if (startingValue.attributeEstimate) { startingStatistic.attributeEstimate = startingValue.attributeEstimate; }
        if (startingValue.modelCharacteristic) { startingStatistic.modelCharacteristic = startingValue.modelCharacteristic; }
    }

    const [evidenceStatisticState, setEvidenceStatisticState] = useState(JSON.parse(JSON.stringify(startingStatistic || {})));
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);
    const [openAdvancedState, setOpenAdvancedState] = useState(false);

    useEffect((() => {
        if (Object.keys(evidenceStatisticState).length > 0) {
            let newEvidenceStatistic = {};
            if (evidenceStatisticState.extension) { newEvidenceStatistic.extension = evidenceStatisticState.extension; }
            if (evidenceStatisticState.description) { newEvidenceStatistic.description = evidenceStatisticState.description; }
            if (Array.isArray(evidenceStatisticState.note) && evidenceStatisticState.note.length > 0) {
                newEvidenceStatistic.note = evidenceStatisticState.note;
            }
            if (evidenceStatisticState.statisticType && Object.keys(evidenceStatisticState.statisticType).length > 0) {
                newEvidenceStatistic.statisticType = evidenceStatisticState.statisticType;
            }
            if (evidenceStatisticState.category && Object.keys(evidenceStatisticState.category).length > 0) {
                newEvidenceStatistic.category = evidenceStatisticState.category;
            }
            if (evidenceStatisticState.quantity && Object.keys(evidenceStatisticState.quantity).length > 0) {
                newEvidenceStatistic.quantity = evidenceStatisticState.quantity;
            }
            if (evidenceStatisticState.numberOfEvents || evidenceStatisticState.numberOfEvents === 0) {
                newEvidenceStatistic.numberOfEvents = evidenceStatisticState.numberOfEvents;
            }
            if (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0) {
                newEvidenceStatistic.numberAffected = evidenceStatisticState.numberAffected;
            }
            if (evidenceStatisticState.sampleSize && Object.keys(evidenceStatisticState.sampleSize).length > 0) {
                newEvidenceStatistic.sampleSize = evidenceStatisticState.sampleSize;
            }
            if (Array.isArray(evidenceStatisticState.attributeEstimate) && evidenceStatisticState.attributeEstimate.length > 0) {
                newEvidenceStatistic.attributeEstimate = evidenceStatisticState.attributeEstimate;
            }
            if (Array.isArray(evidenceStatisticState.modelCharacteristic) && evidenceStatisticState.modelCharacteristic.length > 0) {
                newEvidenceStatistic.modelCharacteristic = evidenceStatisticState.modelCharacteristic;
            }
            if (Object.keys(newEvidenceStatistic).length === 0) {
                newEvidenceStatistic = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceStatistic }; });
        }
    }), [evidenceStatisticState]);

    let statisticTypeDisplay = "";
    if (startingValue.statisticType) {
        if (startingValue.statisticType.coding?.length > 0) {
            if (startingValue.statisticType.coding[0].display) {
                statisticTypeDisplay = startingValue.statisticType.coding[0].display;
            } else if (startingValue.statisticType.coding[0].code) {
                statisticTypeDisplay = startingValue.statisticType.coding[0].code;
            }
        }
        if (startingValue.statisticType.text) {
            statisticTypeDisplay += "   " + startingValue.statisticType.text;
        }
    }
    let statisticValue = "";
    if (startingValue.quantity) {
        let comparator = "";
        if (startingValue.quantity.comparator) {
            comparator = startingValue.quantity.comparator + " ";
        }
        let unit = "";
        if (startingValue.quantity.unit) {
            unit = " " + startingValue.quantity.unit;
        }
        let value = startingValue.quantity.value;
        if (value && !unit && statisticTypeDisplay.replace("   ", "").toLowerCase() === "percentage") {
            unit = "%";
        }
        statisticValue = comparator + value + unit;
    }
    let sampleSizeQuantified = "";
    if (startingValue.sampleSize) {
        if (startingValue.sampleSize.numberOfStudies) {
            sampleSizeQuantified = startingValue.sampleSize.numberOfStudies + " studies";
        }
        if (startingValue.sampleSize.numberOfParticipants) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.numberOfParticipants + " participants";
        }
        if (startingValue.sampleSize.numberAnalyzed) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.numberAnalyzed + " analyzed";
        }
        if (startingValue.sampleSize.knownDataCount) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.knownDataCount + " without missing data";
        }
    }

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.category && <span><b>Category:</b> {startingValue.category.text}</span>}
                {startingValue.description && <span>
                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                </span>}
                {Array.isArray(startingValue.note) && startingValue.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}
                <Table style={{ margin: "4px", width: "600px" }}><Table.Body>
                    <Table.Row><Table.Cell style={{ width: "280px", paddingTop: "6px", paddingBottom: "6px", paddingLeft: "12px" }}>
                        <b>{statisticTypeDisplay}</b>
                    </Table.Cell>
                        <Table.Cell style={{ paddingTop: "6px", paddingBottom: "6px", paddingLeft: "12px" }}>
                            <b>{statisticValue}</b>
                        </Table.Cell></Table.Row>
                </Table.Body></Table>
                {!isNaN(startingValue.numberOfEvents) && <span><b>Number of Events: </b>{startingValue.numberOfEvents}<br /></span>}
                {!isNaN(startingValue.numberAffected) && <span><b>Number Affected: </b>{startingValue.numberAffected}<br /></span>}
                {startingValue.sampleSize && <><b>Sample Size: </b>
                    <div style={{ marginLeft: "24px" }}>
                        {sampleSizeQuantified && <><b></b>{sampleSizeQuantified}<br /></>}
                        {startingValue.sampleSize.description && <span><b>Sample Size Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.sampleSize.description} /><br /></span>}
                        {Array.isArray(startingValue.sampleSize.note) && startingValue.sampleSize.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}
                    </div>
                </>}
                {startingValue.attributeEstimate?.length > 0 &&
                    <Table style={{ margin: "4px" }}>
                        <Table.Header><Table.Row>
                            <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                            <Table.HeaderCell style={{ padding: "6px" }}>Value</Table.HeaderCell>
                            <Table.HeaderCell style={{ padding: "6px" }}>Notes</Table.HeaderCell>
                        </Table.Row></Table.Header>
                        <Table.Body>
                            {startingValue.attributeEstimate.map((attributeEstimate, aeIndex) => {
                                let calculatedPercentageAttribute = false;
                                let attribute = "";
                                if (attributeEstimate.level) {
                                    attribute = 100 * attributeEstimate.level + "% ";
                                }
                                if (attributeEstimate.type) {
                                    if (attributeEstimate.type.coding?.length > 0) {
                                        if (attributeEstimate.type.coding[0].display) {
                                            attribute += attributeEstimate.type.coding[0].display;
                                        } else if (attributeEstimate.type.coding[0].code) {
                                            attribute += attributeEstimate.type.coding[0].code;
                                        }
                                    }
                                    if (attributeEstimate.type.text) {
                                        if (attributeEstimate.type.text.toLowerCase() === "percentage") {
                                            calculatedPercentageAttribute = true;
                                        }
                                        attribute += " " + attributeEstimate.type.text;
                                    }
                                }
                                let attributeValue = "";
                                if (attributeEstimate.quantity) {
                                    let comparator = "";
                                    if (attributeEstimate.quantity.comparator) {
                                        comparator = attributeEstimate.quantity.comparator + " ";
                                    }
                                    let unit = "";
                                    if (attributeEstimate.quantity.unit) {
                                        unit = " " + attributeEstimate.quantity.unit;
                                    }
                                    let attributeEstimateValue = "";
                                    if (attributeEstimate.quantity.value !== undefined) {
                                        attributeEstimateValue = attributeEstimate.quantity.value
                                    }
                                    attributeValue = comparator + attributeEstimate.quantity.value + unit;
                                    if (calculatedPercentageAttribute && attributeEstimate.quantity.value && (comparator === "" || comparator === " ") && attributeEstimate.quantity.unit === "%") {
                                        try {
                                            //The plus symbol belongs here, +parseFloat(4).toFixed(2) === 4 as an int vs parseFloat(4).toFixed(2) === "4.00" as a string
                                            attributeEstimateValue = +parseFloat(attributeEstimate.quantity.value).toFixed(2);
                                            if (attributeEstimateValue.toString() !== "NaN") {
                                                attributeValue = attributeEstimateValue + unit;
                                            }
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                }
                                if (attributeValue === "" && attributeEstimate.range) {
                                    let lowValue = "No Lower Bound";
                                    let highValue = "No Upper Bound";
                                    if (attributeEstimate.range.low?.value !== undefined) {
                                        lowValue = attributeEstimate.range.low.value;
                                        if (attributeEstimate.range.low.unit) {
                                            lowValue += " " + attributeEstimate.range.low.unit;
                                        }
                                    }
                                    if (attributeEstimate.range.high?.value !== undefined) {
                                        highValue = attributeEstimate.range.high.value;
                                        if (attributeEstimate.range.high.unit) {
                                            highValue += " " + attributeEstimate.range.high.unit;
                                        }
                                    }
                                    attributeValue = lowValue + " to " + highValue;
                                }
                                return <Table.Row key={aeIndex}>
                                    <Table.Cell>{attribute}</Table.Cell>
                                    <Table.Cell>{attributeValue}</Table.Cell>
                                    <Table.Cell>
                                        {attributeEstimate.description && <><b>Description: </b><DisplayFromFHIRMarkdown markdown={attributeEstimate.description} /><br /></>}
                                        {attributeEstimate.note && <>{attributeEstimate.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}</>}
                                    </Table.Cell>
                                </Table.Row>
                            }
                            )}
                        </Table.Body>
                    </Table>}
                {(Array.isArray(startingValue.modelCharacteristic) &&
                    startingValue.modelCharacteristic.length > 0) &&
                    startingValue.modelCharacteristic.map((item, itemIndex) => {
                        return <div key={itemIndex}>
                            <p><b>Model Characteristic {itemIndex + 1} of {startingValue.modelCharacteristic.length}</b></p>
                            <div style={{ marginLeft: "24px" }}>
                                <ModelCharacteristicDisplay modelCharactersticInstance={item} />
                            </div>
                        </div>
                    })}
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (dataEntryStyle === "continuous") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed={!!evidenceStatisticState.description}
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                    startingValue={evidenceStatisticState.statisticType} startCollapsed={!!evidenceStatisticState.statisticType}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={continuousStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity} startCollapsed={!!evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState) }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                    <CodeableConceptEntry elementName='category' fieldLabel='Category'
                        startingValue={evidenceStatisticState.category} startCollapsed
                        setResourceState={setEvidenceStatisticState} />        <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                    <br /><br />
                    <span><b>Number Affected:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                            startingValue={evidenceStatisticState.numberAffected}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "dichotomous") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed={!!evidenceStatisticState.description}
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                    startingValue={evidenceStatisticState.statisticType} startCollapsed={!!evidenceStatisticState.statisticType}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={dichotomousStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity} startCollapsed={!!evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState) }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                    <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                    <CodeableConceptEntry elementName='category' fieldLabel='Category'
                        startingValue={evidenceStatisticState.category} startCollapsed
                        setResourceState={setEvidenceStatisticState} />        <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "categorical") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed={!!evidenceStatisticState.category}
                    setResourceState={setEvidenceStatisticState} />
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed={!!evidenceStatisticState.description}
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                    startingValue={evidenceStatisticState.statisticType} startCollapsed={!!evidenceStatisticState.statisticType}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={categoricalStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity} startCollapsed={!!evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState) }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                    <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "comparative") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                {outcomeCategories?.length > 0 && <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed={!!evidenceStatisticState.category}
                    setResourceState={setEvidenceStatisticState} />}
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed={!!evidenceStatisticState.description}
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                    startingValue={evidenceStatisticState.statisticType} startCollapsed={!!evidenceStatisticState.statisticType}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={comparativeStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity} startCollapsed={!!evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                {(outcomeHandling === "continuous") && <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={!!evidenceStatisticState.attributeEstimate}
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />}
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState) }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    {(outcomeHandling !== "continuous") && <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />}
                    <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                    {!(outcomeCategories?.length > 0) && <CodeableConceptEntry elementName='category' fieldLabel='Category'
                        startingValue={evidenceStatisticState.category} startCollapsed
                        setResourceState={setEvidenceStatisticState} />}
                </div>}
            </div>
        </>
    } else {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                    startingValue={evidenceStatisticState.statisticType}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                    setResourceState={setEvidenceStatisticState} />
                <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span><b>Number of Events:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                        startingValue={evidenceStatisticState.numberOfEvents}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <br /><br />
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
            </div>
        </>
    }
});

const certaintyTypeValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/certainty-type",
            "code": "Overall",
            "display": "Overall certainty"
        }]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "RiskOfBias",
                "display": "Risk of bias"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Inconsistency",
                "display": "Inconsistency"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Indirectness",
                "display": "Indirectness"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Imprecision",
                "display": "Imprecision"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "PublicationBias",
                "display": "Publication bias"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "DoseResponseGradient",
                "display": "Dose response gradient"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "PlausibleConfounding",
                "display": "Plausible confounding"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "LargeEffect",
                "display": "Large effect"
            }
        ]
    }
];
const certaintyRatingValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/certainty-rating",
            "code": "high",
            "display": "High quality"
        }]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "moderate",
                "display": "Moderate quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "low",
                "display": "Low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "very-low",
                "display": "Very low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "no-concern",
                "display": "no serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "serious-concern",
                "display": "serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "very-serious-concern",
                "display": "very serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "extremely-serious-concern",
                "display": "extremely serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "present",
                "display": "present"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "absent",
                "display": "absent"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "no-change",
                "display": "no change to rating"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode1",
                "display": "reduce rating: -1"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode2",
                "display": "reduce rating: -2"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode3",
                "display": "reduce rating: -3"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "upcode1",
                "display": "increase rating: +1"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "upcode2",
                "display": "increase rating: +2"
            }
        ]
    }
];

const EvidenceCertaintyEntry = memo(({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {
    let startingCertainty = {
        "description": "", "note": [], "type": "", "rating": "", "rater": [], "subcomponent": []
    };
    if (!startingValue) {
        startingValue = "";
    } else {
        if (startingValue.extension) { startingCertainty.extension = startingValue.extension; }
        if (startingValue.description) { startingCertainty.description = startingValue.description; }
        if (startingValue.note) { startingCertainty.note = startingValue.note; }
        if (startingValue.type) { startingCertainty.type = startingValue.type; }
        if (startingValue.rating) { startingCertainty.rating = startingValue.rating; }
        if (startingValue.rater) { startingCertainty.rater = startingValue.rater; }
        if (startingValue.subcomponent) { startingCertainty.subcomponent = startingValue.subcomponent; }
    }
    const [evidenceCertaintyState, setEvidenceCertaintyEstimateState] = useState(JSON.parse(JSON.stringify(startingCertainty || {})));
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect((() => {
        if (Object.keys(evidenceCertaintyState).length > 0) {
            let newCertainty = {};
            if (evidenceCertaintyState.extension) { newCertainty.extension = evidenceCertaintyState.extension; }
            if (evidenceCertaintyState.description) { newCertainty.description = evidenceCertaintyState.description; }
            if (Array.isArray(evidenceCertaintyState.note) && evidenceCertaintyState.note.length > 0) {
                newCertainty.note = evidenceCertaintyState.note;
            }
            if (evidenceCertaintyState.type && Object.keys(evidenceCertaintyState.type).length > 0) {
                newCertainty.type = evidenceCertaintyState.type;
            }
            if (evidenceCertaintyState.rating && Object.keys(evidenceCertaintyState.rating).length > 0) {
                newCertainty.rating = evidenceCertaintyState.rating;
            }
            if (Array.isArray(evidenceCertaintyState.rater) && evidenceCertaintyState.rater.length > 0) {
                newCertainty.rater = evidenceCertaintyState.rater;
            }
            if (Array.isArray(evidenceCertaintyState.subcomponent) && evidenceCertaintyState.subcomponent.length > 0) {
                newCertainty.subcomponent = evidenceCertaintyState.subcomponent;
            }
            if (Object.keys(newCertainty).length === 0) {
                newCertainty = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newCertainty }; });
        }
    }), [evidenceCertaintyState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                <Table style={{ margin: "4px" }}>
                    <Table.Header><Table.Row>
                        <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Rating</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Comments</Table.HeaderCell>
                    </Table.Row></Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                {startingValue.type && <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.type} />}
                                {startingValue.rater && <p>Rated by {startingValue.rater.join("; ")}</p>}
                            </Table.Cell>
                            <Table.Cell>
                                {startingValue.rating && <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.rating} />}
                            </Table.Cell>
                            <Table.Cell>
                                {startingValue.description && <>
                                    <DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                                </>}
                                {startingValue.note && <>
                                    {startingValue.note.map((note, noteIndex) => {
                                        return <span key={noteIndex}>
                                            <b>Note:</b> {note.text}<br />
                                        </span>
                                    })}
                                </>}
                            </Table.Cell>
                        </Table.Row>
                        {(Array.isArray(startingValue.subcomponent) && startingValue.subcomponent.length > 0) &&
                            startingValue.subcomponent.map((part, partIndex) => {
                                return <Table.Row key={partIndex}>
                                    <Table.Cell>
                                        {part.type && <DisplayFromFHIRCodeableConcept codeableConcept={part.type} />}
                                        {part.rater && <p>Rated by {part.rater.join("; ")}</p>}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {part.rating && <DisplayFromFHIRCodeableConcept codeableConcept={part.rating} />}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {part.description && <>
                                            <DisplayFromFHIRMarkdown markdown={part.description} /><br />
                                        </>}
                                        {part.note && <>
                                            {part.note.map((note, noteIndex) => {
                                                return <span key={noteIndex}>
                                                    <b>Note:</b> {note.text}<br />
                                                </span>
                                            })}
                                        </>}
                                    </Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                </Table>
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description/Summary' startCollapsed
                    startingValue={evidenceCertaintyState.description}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.note} setResourceState={setEvidenceCertaintyEstimateState} />
                <CodeableConceptEntry elementName='type' fieldLabel='Attribute Type'
                    startingValue={evidenceCertaintyState.type}
                    codeableConceptLevelValueSet={certaintyTypeValueSet}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <CodeableConceptEntry elementName='rating' fieldLabel='Rating Value'
                    startingValue={evidenceCertaintyState.rating}
                    codeableConceptLevelValueSet={certaintyRatingValueSet}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='string' elementName='rater' fieldLabel='Rater (Name)'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.rater} setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='EvidenceCertainty' elementName='subcomponent' fieldLabel='Subcomponent'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.subcomponent} setResourceState={setEvidenceCertaintyEstimateState} />
            </div>
        </>
    }
})


const pValueComparatorOptions = [{ "key": "0", "value": "=", "text": "=" }, { "key": "1", "value": "<", "text": "<" }, { "key": "2", "value": ">", "text": ">" }];
const InitialStatisticEntry = memo(({ setResourceState }) => {

    const [initialStatisticState, setInitialStatisticState] = useState({});

    useEffect(() => {
        let attributeEstimate = [];
        if ((initialStatisticState.lowValue || initialStatisticState.lowValue === 0) &&
            (initialStatisticState.highValue || initialStatisticState.highValue === 0)) {
            let lowEnd = { value: initialStatisticState.lowValue };
            let highEnd = { value: initialStatisticState.highValue };
            if (initialStatisticState.quantity?.unit) {
                lowEnd.unit = initialStatisticState.quantity.unit;
                highEnd.unit = initialStatisticState.quantity.unit;
            }
            if (initialStatisticState.quantity?.system) {
                lowEnd.system = initialStatisticState.quantity.system;
                highEnd.system = initialStatisticState.quantity.system;
            }
            if (initialStatisticState.quantity?.code) {
                lowEnd.code = initialStatisticState.quantity.code;
                highEnd.code = initialStatisticState.quantity.code;
            }
            let instance = {
                type: {
                    coding: [{
                        system: "https://fevir.net/sevco",
                        code: "STATO:0000196",
                        display: "confidence interval"
                    }]
                },
                level: 0.95,
                range: { low: lowEnd, high: highEnd }
            };
            attributeEstimate.push(instance);
        }
        if (initialStatisticState.pValue) {
            let instance = {
                type: {
                    coding: [{
                        system: "https://fevir.net/sevco",
                        code: "STATO:0000700",
                        display: "p-value"
                    }]
                },
                quantity: {
                    comparator: initialStatisticState.comparator,
                    value: initialStatisticState.pValue
                }
            };
            if (initialStatisticState.comparator !== ">" && initialStatisticState.comparator !== "<") {
                delete instance.quantity.comparator;
            }
            attributeEstimate.push(instance);
        }
        if (initialStatisticState.standardDeviation) {
            let instance = {
                type: {
                    coding: [{
                        system: "https://fevir.net/sevco",
                        code: "STATO:0000684",
                        display: "standard deviation for sample"
                    }]
                },
                quantity: {
                    value: initialStatisticState.standardDeviation
                }
            };
            if (initialStatisticState.quantity?.unit) {
                instance.quantity.unit = initialStatisticState.quantity.unit;
            }
            if (initialStatisticState.quantity?.system) {
                instance.quantity.system = initialStatisticState.quantity.system;
            }
            if (initialStatisticState.quantity?.code) {
                instance.quantity.code = initialStatisticState.quantity.code;
            }
            attributeEstimate.push(instance);
        }
        setInitialStatisticState(prevState => { return { ...prevState, attributeEstimate: attributeEstimate }; });
    }, [initialStatisticState.lowValue, initialStatisticState.highValue,
    initialStatisticState.comparator, initialStatisticState.pValue, initialStatisticState.standardDeviation]);

    const addStatistic = () => {
        if ((initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
            initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) &&
            (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) &&
            initialStatisticState.missingDataCount > (initialStatisticState.numberOfParticipants || initialStatisticState.numberAnalyzed)
        ) {
            alert("Missing data count cannot be larger than sample size. Correct then +Add Statistic.");
        } else if (!initialStatisticState.statisticType) {
            alert("Please specify a statistic type then +Add Statistic.");
        } else if (!initialStatisticState.quantity) {
            alert("Please specify a statistic value (Quantity) then +Add Statistic.");
        } else {
            let statistic = {
                statisticType: initialStatisticState.statisticType,
                quantity: initialStatisticState.quantity
            };
            if (initialStatisticState.numberAffected || initialStatisticState.numberAffected === 0) {
                statistic.numberAffected = initialStatisticState.numberAffected;
            }
            if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
                initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                let sampleSize = {};
                if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0) {
                    sampleSize.numberOfParticipants = initialStatisticState.numberOfParticipants;
                };
                if (initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                    sampleSize.numberAnalyzed = initialStatisticState.numberAnalyzed;
                };
                if (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) {
                    let denominator = initialStatisticState.numberOfParticipants || initialStatisticState.numberAnalyzed;
                    let knownDataCount = denominator - initialStatisticState.missingDataCount;
                    sampleSize.knownDataCount = knownDataCount;
                }
                statistic.sampleSize = sampleSize;
            }
            if (initialStatisticState.attributeEstimate) {
                statistic.attributeEstimate = initialStatisticState.attributeEstimate;
            }
            setResourceState(prevState => { return { ...prevState, statistic: [statistic] }; });
        }
    }

    return <>
        <span><b>Sample Size:</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberOfParticipants' fieldLabel='Number of Participants'
                startingValue={initialStatisticState.numberOfParticipants}
                setResourceState={setInitialStatisticState} />
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberAnalyzed' fieldLabel='Number Analyzed'
                startingValue={initialStatisticState.numberAnalyzed}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Missing Data Count:</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='missingDataCount' fieldLabel='Number missing data for this outcome'
                startingValue={initialStatisticState.missingDataCount}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Number having this outcome (for boolean outcomes):</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number affected'
                startingValue={initialStatisticState.numberAffected}
                setResourceState={setInitialStatisticState} />
        </span>
        {(initialStatisticState.numberAffected || initialStatisticState.numberAffected === 0) && <div>
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Add proportion as the statistic value."}
                onClick={() => {
                    let denominator = initialStatisticState.numberAnalyzed;
                    if (!denominator) {
                        denominator = initialStatisticState.numberOfParticipants;
                        if (initialStatisticState.missingDataCount) {
                            denominator -= initialStatisticState.missingDataCount;
                        }
                    }
                    setInitialStatisticState(prevState => {
                        return {
                            ...prevState,
                            statisticType: {
                                coding: [{
                                    system: "https://fevir.net/sevco",
                                    code: "STATO:0000607",
                                    display: "proportion"
                                }]
                            },
                            quantity: { value: initialStatisticState.numberAffected / denominator }
                        };
                    })
                }}
                disabled={!initialStatisticState.numberOfParticipants && !initialStatisticState.numberAnalyzed} />
            <br />
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Add percentage as the statistic value."}
                onClick={() => {
                    let denominator = initialStatisticState.numberAnalyzed;
                    if (!denominator) {
                        denominator = initialStatisticState.numberOfParticipants;
                        if (initialStatisticState.missingDataCount) {
                            denominator -= initialStatisticState.missingDataCount;
                        }
                    }
                    setInitialStatisticState(prevState => {
                        return {
                            ...prevState,
                            statisticType: {
                                coding: [{
                                    system: "https://fevir.net/sevco",
                                    code: "STATO:0000639",
                                    display: "percentage"
                                }]
                            },
                            quantity: {
                                value: 100 * initialStatisticState.numberAffected / denominator,
                                unit: "%", system: "http://unitsofmeasure.org", code: "%"
                            }
                        };
                    })
                }}
                disabled={!initialStatisticState.numberOfParticipants && !initialStatisticState.numberAnalyzed} />
            <br />
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Use count as the statistic value."}
                onClick={() => {
                    setInitialStatisticState(prevState => {
                        let count = initialStatisticState.numberAffected;
                        return {
                            ...prevState,
                            numberAffected: "",
                            statisticType: {
                                coding: [{
                                    system: "https://fevir.net/sevco",
                                    code: "STATO:0000047",
                                    display: "count"
                                }]
                            },
                            quantity: {
                                value: count,
                                system: "http://unitsofmeasure.org", code: "1"
                            }
                        };
                    })
                }}
                disabled={!initialStatisticState.numberOfParticipants && initialStatisticState.numberOfParticipants !== 0 &&
                    !initialStatisticState.numberAnalyzed && initialStatisticState.numberAnalyzed !== 0} />
        </div>}
        <br /><br />
        <span><b>Statistic type:</b>
            &nbsp;&nbsp;
            <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                startingValue={initialStatisticState.statisticType}
                valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Statistic Value (Quantity):</b>
            &nbsp;&nbsp;
            <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                startingValue={initialStatisticState.quantity}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>95% Confidence Interval:</b>
            &nbsp;&nbsp;
            <DecimalEntry elementName='lowValue' fieldLabel='Low Value'
                startingValue={initialStatisticState.lowValue}
                setResourceState={setInitialStatisticState} />
            &nbsp;&nbsp;
            <DecimalEntry elementName='highValue' fieldLabel='High Value'
                startingValue={initialStatisticState.highValue}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>p value:</b>
            &nbsp;&nbsp;
            <Dropdown className="dropdownWithClearIconUpperRight" name="comparator" placeholder="Comparator"
                closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
                style={{ minWidth: "18%", width: "18%" }}
                options={pValueComparatorOptions}
                value={initialStatisticState.comparator || ""}
                onChange={(e, data) => {
                    setInitialStatisticState(prevState => { return { ...prevState, comparator: data.value }; });
                }}
            />
            &nbsp;&nbsp;
            <DecimalEntry elementName='pValue' fieldLabel='p Value'
                startingValue={initialStatisticState.pValue}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span>Standard deviation:
            &nbsp;&nbsp;
            <DecimalEntry elementName='standardDeviation' fieldLabel='Standard deviation'
                startingValue={initialStatisticState.standardDeviation}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <Button className="formButton" style={{ color: "blue", marginBottom: "12px" }}
            content={"+ Create initial statistic"}
            onClick={() => {
                addStatistic();
            }} />
    </>
});

const EvidenceResourceEdit = memo(({ foi }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let initialResourceJson = newResourceDetail.resourceJson;
    let resourceJson = newResourceDetail.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({
        title: resourceJson.title,
        name: resourceJson.name,
        description: resourceJson.description,
        assertion: resourceJson.assertion,
        statistic: resourceJson.statistic,
        certainty: resourceJson.certainty
    });

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.title)) {
                console.log("resourceUpdate for Evidence.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "title",
                    previousInitialValue,
                    editResourceState.title);
            }
        }
    }, [editResourceState.title]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.name !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.name)) {
                console.log("resourceUpdate for Evidence.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "name",
                    previousInitialValue,
                    editResourceState.name);
            }
        }
    }, [editResourceState.name]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.description;
            previousFinalValue = newResourceDetail.revisedResourceJson.description;
            newResourceDetail.revisedResourceJson.description = editResourceState.description;
            if (editResourceState.description !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.description)) {
                console.log("resourceUpdate for Evidence.description");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "markdown",
                    "description",
                    previousInitialValue,
                    editResourceState.description);
            }
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.assertion;
            previousFinalValue = newResourceDetail.revisedResourceJson.assertion;
            newResourceDetail.revisedResourceJson.assertion = editResourceState.assertion;
            if (editResourceState.assertion !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.assertion)) {
                console.log("resourceUpdate for Evidence.assertion");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "markdown",
                    "assertion",
                    previousInitialValue,
                    editResourceState.assertion);
            }
        }
    }, [editResourceState.assertion]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.statistic;
            previousFinalValue = newResourceDetail.revisedResourceJson.statistic;
            newResourceDetail.revisedResourceJson.statistic = editResourceState.statistic;
            if (editResourceState.statistic !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.statistic)) {
                console.log("resourceUpdate for Evidence.statistic");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfEvidenceStatistic",
                    "statistic",
                    previousInitialValue,
                    editResourceState.statistic);
            }
        }
    }, [editResourceState.statistic]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.certainty;
            previousFinalValue = newResourceDetail.revisedResourceJson.certainty;
            newResourceDetail.revisedResourceJson.certainty = editResourceState.certainty;
            if (editResourceState.certainty !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.certainty)) {
                console.log("resourceUpdate for Evidence.certainty");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfEvidenceCertainty",
                    "certainty",
                    previousInitialValue,
                    editResourceState.certainty);
            }
        }
    }, [editResourceState.certainty]);

    return <div style={{ marginLeft: "24px" }}>
        {editResourceState && <>
            <StringEntry elementName='title'
                fieldLabel={'Title (Human-friendly Label for the Evidence Resource)'}
                startingValue={editResourceState.title || ""}
                required={(resourceJson?.description || resourceJson?.statistic)}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Description'}
                startingValue={editResourceState.description || ""}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='assertion' fieldLabel={'Assertion'}
                startingValue={editResourceState.assertion || ""}
                setResourceState={setEditResourceState} />
            {editResourceState?.statistic?.length ?
                <ArrayEntry datatype='EvidenceStatistic' elementName='statistic'
                    fieldLabel='Statistic' startingValue={editResourceState.statistic}
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                    setResourceState={setEditResourceState} />
                :
                <InitialStatisticEntry setResourceState={setEditResourceState} />
            }
            <ArrayEntry datatype='EvidenceCertainty' elementName='certainty'
                fieldLabel='Certainty' startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                startingValue={editResourceState.certainty}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name' fieldLabel='Name (Machine Label for the Evidence Resource)'
                startingValue={editResourceState.name || ""} setResourceState={setEditResourceState} />
        </>}
    </div>
})

export default EvidenceResourceEdit;
export {
    EvidenceStatisticEntry, EvidenceCertaintyEntry, EvidenceStatisticSampleSizeEntry,
    EvidenceStatisticAttributeEstimateEntry, InitialStatisticEntry
};